<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      系统设置
      <small>/&nbsp;支付配置</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">支付配置列表</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
                <a
                  class="btn btn-primary ButtonColor LineSpacing"
                  @click="AddClick()"
                  style="float:right;"
                >新增</a>
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60"  align="center"></el-table-column>
                  <el-table-column prop="enterpriseName" label="支付企业名称" align="center"></el-table-column>

                  <el-table-column prop="enterpriseCode" label="支付企业编码" align="center"></el-table-column>

                  <el-table-column prop="paytype" label="支付方式" align="center"></el-table-column>
                  <el-table-column prop="merchantId" label="商户号" align="center"></el-table-column>
                  <el-table-column prop="bankCode" label="银行代码" align="center"></el-table-column>
                  <el-table-column prop="currentstatus" label="状态" align="center"></el-table-column>

                  <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="EditClick(scope.row)"
                      >编辑</a>
                      <a
                        class="btn btn-warning btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DeleteClick(scope.row)"
                      >删除</a>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="支付企业名称:" prop="enterpriseName">
            <el-input v-model="ruleForm.enterpriseName" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="支付企业编码:" prop="enterpriseCode">
            <el-input v-model="ruleForm.enterpriseCode" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="商户号:" prop="merchantId">
            <el-input v-model="ruleForm.merchantId" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="支付方式:" prop="payType">
            <el-select
              v-model="ruleForm.payType"
              placeholder="请选择"
              class="DistributorMargin"
              style="width:100%"
            >
              <el-option
                v-for="item in PayTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "PaySettings",
  data() {
    var checkenterpriseCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("支付企业编码编号不能为空"));
      }
      setTimeout(() => {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,10}$/;
        if (!reg.test(value)) {
          callback(new Error("支付企业编码编号8-10位,字母数字组合"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      outerVisible: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      ruleForm: {
        enterpriseCode: "",
        enterpriseName: "",

        payType: "",
        merchantId: ""
      },
      disabled: false,
      rules: {
        enterpriseCode: [
          {
            required: true,
            message: "请输入支付企业编码编号",
            trigger: "blur"
          },
          { validator: checkenterpriseCode, trigger: "blur" }
        ],
        enterpriseName: [
          { required: true, message: "请输入支付企业名称", trigger: "blur" }
        ],

        merchantId: [
          { required: true, message: "请输入商户号", trigger: "blur" }
        ],
        payType: [
          { required: true, message: "请输入支付方式", trigger: "blur" }
        ]
      },
      PayTypeOptions: [
        {
          value: "1",
          label: "支付宝"
        },
        {
          value: "2",
          label: "微信"
        },
        {
          value: "3",
          label: "汇付支付宝扫码"
        },
        {
          value: "4",
          label: "汇付微信扫码"
        }
      ],
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1
    };
  },
  mounted: function() {
    this.initdata();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },

    EditClick(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
      this.ruleForm = MethodsBus.cloneRow(row);
      this.ruleForm.payType = row.payType.toString();
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
      this.ruleForm = {};
      this.outerVisible = true;

      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
      this.initdata();
    },

    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cPayEnterpriseController/updatePayEnterprise",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                id: this.ruleForm.id,
                enterpriseCode: this.ruleForm.enterpriseCode,
                enterpriseName: this.ruleForm.enterpriseName,
                payType: this.ruleForm.payType,
                merchantId: this.ruleForm.merchantId
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "修改成功",
                    type: "success"
                  });
                } else {
                  that.$notify({
                    title: "失败",
                    message: response.data.message,
                    type: "error"
                  });
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cPayEnterpriseController/addPayEnterprise",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                enterpriseCode: this.ruleForm.enterpriseCode,
                enterpriseName: this.ruleForm.enterpriseName,
                payType: this.ruleForm.payType,
                merchantId: this.ruleForm.merchantId
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  that.$notify({
                    title: "失败",
                    message: response.data.message,
                    type: "error"
                  });
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      axios
        .post(
          "distribution/B2cPayEnterpriseController/delPayEnterprise?id=" +
            this.CurrentSelection.id
        )
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            that.$notify({
              title: "失败",
              message: response.data.message,
              type: "error"
            });
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cPayEnterpriseController/queryPayEnterprise",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            for (var i in response.data.data) {
              response.data.data[i].ordernumber = Number(i) + 1;
              if (response.data.data[i].status === 0) {
                response.data.data[i].currentstatus = "删除";
              } else if (response.data.data[i].status === 1) {
                response.data.data[i].currentstatus = "正常";
              }
              if (response.data.data[i].payType === 1) {
                response.data.data[i].paytype = "支付宝";
              } else if (response.data.data[i].payType === 2) {
                response.data.data[i].paytype = "微信";
              } else if (response.data.data[i].payType === 3) {
                response.data.data[i].paytype = "汇付支付宝扫码";
              } else if (response.data.data[i].payType === 4) {
                response.data.data[i].paytype = "汇付微信扫码";
              }
            }

            that.UserManagementList = response.data.data;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/PaySettings.vue